var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetalOrigin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#73AAE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5096 20.248C17.7209 19.6047 17.8263 19.2834 18.0416 19.062C18.1438 18.9576 18.2625 18.8707 18.3929 18.8047C18.6669 18.6667 19.0003 18.6667 19.6669 18.6667C20.3336 18.6667 20.6669 18.6667 20.9416 18.8047C21.0723 18.8705 21.1894 18.9563 21.2929 19.062C21.5083 19.2834 21.6129 19.6047 21.8243 20.248L22.0416 20.9114C22.3043 21.7127 22.4356 22.1127 22.2396 22.39C22.0429 22.6667 21.6283 22.6667 20.7983 22.6667H18.5363C17.7063 22.6667 17.2909 22.6667 17.0949 22.39C16.8983 22.1127 17.0296 21.7127 17.2923 20.9114L17.5096 20.248ZM13.8429 14.9147C14.0536 14.2714 14.1596 13.95 14.3743 13.7287C14.4778 13.6229 14.5949 13.5372 14.7256 13.4714C15.0003 13.3334 15.3336 13.3334 16.0003 13.3334C16.6669 13.3334 17.0003 13.3334 17.2749 13.4714C17.4056 13.5372 17.5227 13.6229 17.6263 13.7287C17.8409 13.95 17.9463 14.2714 18.1576 14.9147L18.3749 15.578C18.6376 16.3794 18.7683 16.7794 18.5729 17.0567C18.3763 17.3334 17.9616 17.3334 17.1309 17.3334H14.8696C14.0389 17.3334 13.6243 17.3334 13.4283 17.0567C13.2316 16.7794 13.3629 16.3794 13.6256 15.578L13.8429 14.9147ZM10.1763 20.248C10.3876 19.6047 10.4929 19.2834 10.7083 19.062C10.8109 18.9563 10.9281 18.8705 11.0596 18.8047C11.3336 18.6667 11.6669 18.6667 12.3336 18.6667C13.0003 18.6667 13.3336 18.6667 13.6083 18.8047C13.7389 18.8705 13.8561 18.9563 13.9596 19.062C14.1749 19.2834 14.2796 19.6047 14.4909 20.248L14.7083 20.9114C14.9709 21.7127 15.1023 22.1127 14.9063 22.39C14.7096 22.6667 14.2949 22.6667 13.4649 22.6667H11.2029C10.3729 22.6667 9.95761 22.6667 9.76161 22.39C9.56494 22.1127 9.69628 21.7127 9.95894 20.9114L10.1763 20.248Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33337V10.6667M13 10.3334L14 11.3334M19 10.3334L18 11.3334",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetalOrigin);
export default __webpack_public_path__ + "static/media/metal_origin.5f57546a340f65e8dbaa9d5645d56e82.svg";
export { ForwardRef as ReactComponent };